import styled from 'foundations-theming/utils';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITile from 'UIComponents/tile/UITile';
import ExecutionActionName from 'automation-ui-log-events/components/execution-results/components/ExecutionActionName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TitleContainer = styled.div.withConfig({
  displayName: "ExecutionEventTable__TitleContainer",
  componentId: "sc-2hmx5q-0"
})(["padding-top:10px;padding-bottom:10px;"]);
const StyledUITile = styled(UITile).withConfig({
  displayName: "ExecutionEventTable__StyledUITile",
  componentId: "sc-2hmx5q-1"
})(["padding:8px 12px;border-bottom:none;:last-child{border-bottom:1px solid ", ";}"], ({
  theme
}) => theme.color['do-not-use-great-white']);
const ExecutionEventTable = ({
  titleContent,
  executionResults,
  flowObjectTypeId,
  actionType
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(TitleContainer, {
    children: titleContent
  }), /*#__PURE__*/_jsx("div", {
    children: executionResults.map(executionResult => /*#__PURE__*/_jsx(StyledUITile, {
      distance: "flush",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(ExecutionActionName, {
          entityId: executionResult.getEntityId(),
          entityType: executionResult.getEntityType(),
          objectTypeId: executionResult.getObjectTypeId() || flowObjectTypeId,
          fullEmailAddress: executionResult.getFullEmailAddress(),
          actionType: actionType
        })
      })
    }, executionResult.getEntityId()))
  })]
});
export default ExecutionEventTable;